
<ng-container *ngIf="!showImageGeneration; else checkout">
  <app-shop (showGeneration)="onShowImagesGeneration($event)"></app-shop>
</ng-container>

<ng-template #checkout>
  <app-checkout *ngIf="showImageGeneration"
                [shopImagesGenerationInfo]="shopGenerationInfo"
                (shopGenerationFinished)="hideImagesGeneration()"></app-checkout>
</ng-template>



